import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/authProvider';
import { TablePreferencesProvider } from './context/tablePreferencesProvider';
import { ToastProvider } from './context/toastProvider';
import { initSentry } from './sentry';
import ErrorBoundary from './components/utils/errorBoundary';

initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <React.StrictMode>
      <AuthProvider>
        <TablePreferencesProvider>
          <ToastProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/*" element={<App/>}/>
              </Routes>
            </BrowserRouter>
          </ToastProvider>
        </TablePreferencesProvider>
      </AuthProvider>
    </React.StrictMode>
  </ErrorBoundary>
);
